export default class ApiResponse {
  constructor(public original: Response) {}

  get ok(): boolean {
    return this.original.ok;
  }
}
